module.exports = __webpack_public_path__ + "static/media/qrcode.2edd5a0e.svg";